import { render } from "./IncomeReport.vue?vue&type=template&id=0048eb29&scoped=true"
import script from "./IncomeReport.vue?vue&type=script&lang=js"
export * from "./IncomeReport.vue?vue&type=script&lang=js"

import "./IncomeReport.vue?vue&type=style&index=0&id=0048eb29&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0048eb29"]])

export default __exports__